import React, { Component } from 'react';
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
class CsaHome extends Component{
    render(){
        return(
            <React.Fragment>
                <section className="tab-product m-0">
                <div className="csa-home">
                    <div className="container">
                        <div className="container-tab mx-auto">
                            <div class="row" style={{margin:0}}>
                                <div class="col-md-8 mx-auto" style={{paddingBottom:30}}>
                                    <div className="row" style={{paddingBottom:10}}>
                                        <div className="col-sm-12 text-center">
                                            <div className="mini-title">
                                                <span className="mx-auto">CSA Home</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div >
                                        <div className="row csa-home-list" style={{margin:0}}>
                                        <article className="col-md-6">
                                        <Link to="">
                                        <div className="services-wrap" ><div className='custom_tab'>
                                            <div className="icon">
                                                <i className="fa fa-shopping-cart"></i>
                                            </div>
                                            <div className="entry-container">
                                                <div className="entry-header">
                                                    <h2 className="entry-title" style={window.innerWidth>599?{paddingBottom:26}:{}}>
                                                            Shopping 
                                                    </h2>
                                                </div>
                                               
                                            </div>
                                            </div>
                                        </div>
                                        </Link>
                                        </article>
                                        <article className="col-md-6">
                                        <Link to="/csa-search">
                                        <div className="services-wrap" ><div className='custom_tab'>
                                            <div className="icon">
                                                <i class="fa fa-search"></i>
                                            </div>

                                            <div className="entry-container">
                                                <div className="entry-header">
                                                    <h2 className="entry-title">
                                                            Product Lookup
                                                    </h2>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                        </Link>
                                        </article>
                                        <div className='col-12' style={{padding:0,display:'flex',justifyContent:'center'}}>
                                        <article className="col-md-6">
                                        <Link to="/csa-consumer">
                                        <div className="services-wrap" ><div className='custom_tab'>
                                            <div className="icon">
                                                <i className="fa fa-user"></i>
                                            </div>
                                            <div className="entry-container">
                                                <div className="entry-header">
                                                    <h2 className="entry-title">
                                                            Consumer Details
                                                    </h2>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                        </Link>
                                        </article>
                                        </div>
                                        {/* <article className="col-md-6">
                                        <Link to="/csa-orderhome">
                                        <div className="services-wrap" ><div className='custom_tab'>
                                            <div className="icon">
                                            <i className="fa fa-archive" aria-hidden="true"></i>
                                            </div>
                                            <div className="entry-container">
                                                <div className="entry-header">
                                                    <h2 className="entry-title" >
                                                        Order Fulfillment  
                                                    </h2>
                                                </div>
                                            </div>
                                        </div>
                                        </div>
                                        </Link>
                                        </article> */}
                                        </div>
                                    </div>
                                 
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                </section>        
            </React.Fragment>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    csaVariants: state.csa.csaVariants,
    connection_id: state.tenant.connection_id,
    csaProducts: state.csa.csaProducts,
});

export default connect(
    mapStateToProps,
)(withRouter(CsaHome));